import { Tooltip } from "antd";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import PlayButtton from "../../SharedComponent/ActionButtons/PlayButtton";
import InfoButton from "../../SharedComponent/ActionButtons/InfoButton";
import DeleteButton from "../../SharedComponent/ActionButtons/DeleteButton";
import DownloadButton from "../../SharedComponent/ActionButtons/DownloadButton";
import { getDownloadPackdetails, openDownloadModal } from "../../../redux/Transcribe/TranscribeAction";
import { useNavigate } from "react-router";

interface CompletedActionColumnProps {
  record: any;
}

function CompletedActionColumn({ record }: CompletedActionColumnProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <div className="d-flex gap-2 w-100 justify-content-center">
      {record.status === "QC_COMPLETE" && (
        <>
          {record.isExportResultAvailable === 1 ? (
            <DownloadButton
              onClick={() => {
                dispatch(openDownloadModal());
                dispatch(getDownloadPackdetails(record.packId));
              }}
            />
          ) : (
            <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
          )}
          <PlayButtton
            disabled={false}
            record={record}
          />
          <InfoButton disabled={true} />
          <DeleteButton disabled={true} />
        </>
      )}
    </div>
  );
}

export default CompletedActionColumn;
